import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-editpartner',
  templateUrl: './editpartner.component.html',
  styleUrls: ['./editpartner.component.css']
})
export class EditpartnerComponent implements OnInit {

  registerForm: FormGroup;
  Editpartner: any = {};

  constructor(
    private formBuilder: FormBuilder,
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // console.log(this.route.snapshot.params.id);
    this.loadPartner(this.route.snapshot.params.id);
    this.registerForm = this.formBuilder.group({
      tanggalinput: ['', Validators.required],
      id: ['', Validators.required],
      nama: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      tlp1: ['', Validators.required],
      tlp2: ['', Validators.required]
    }, {
            
    });
  }

  loadPartner(id:any) {
    return this.partnerService.GetEditPartner(id).subscribe((output: any) => {
      console.log(output);
      this.Editpartner = output.data;
    })
  }

  submit() {}

}
